import React, { useEffect } from "react";
import Router from "./routes";
import "./Styles/globals.css";
import { Toaster } from "react-hot-toast";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import store, { persistor } from "./Redux/store";
import LottieAnimation from "./Animations/LottieAnimation";
import { generateToken, messaging } from "./Firebase/firebase";
import { onMessage } from "firebase/messaging";
import toast from "react-hot-toast";
import { useSelector, useDispatch } from "react-redux";
import { sendFirebaseToken } from "./Redux/Actions/authActions";
import ErrorBoundary from "./errorBoundary";
import { logout } from "./Redux/Actions/authActions";
// import { isTokenExpired } from "./Utils/checkTokenExpiry";
import { getEnums } from "./Redux/Actions/enumsActions";

function App() {
  const dispatch = useDispatch();

  const { admin, isAuthenticated } = useSelector((state) => state.admin || {});

  // useEffect(() => {
  //   const token = admin?.data?.token;

  //   if (token && isTokenExpired(token)) {
  //     dispatch(logout());
  //     window.location.href = "/"; 
  //   }
  // }, [dispatch, admin]);

  useEffect(() => {
    if (!isAuthenticated) return;

    // const TWO_DAYS = 2 * 24 * 60 * 60 * 1000;
    const TWO_DAYS = Number(process.env.REACT_APP_DAY_OF_LOGOUT);
    // const TWO_DAYS =  60 * 1000;
    const loginTime = Number(localStorage.getItem("loginTime"));
    const elapsed = Date.now() - loginTime;
    const remainingTime = TWO_DAYS - elapsed;

    if (remainingTime <= 0) {
      dispatch(logout());
      return;
    }

    const timer = setTimeout(() => {
      dispatch(logout());
      toast.error("Session expired");
      window.location.href = "/";
    }, remainingTime);

    return () => clearTimeout(timer);
  }, [isAuthenticated, dispatch]);


  useEffect(() => {
    const getTokenAndSave = async () => {
      const token = await generateToken();
      if (token) {
        dispatch(
          sendFirebaseToken({
            admin_id: admin?.data?._id,
            firebase_token: token,
          })
        );
        dispatch(getEnums());
      }
    };

    getTokenAndSave();
    onMessage(messaging, (payload) => {
      toast(payload.notification.body);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ErrorBoundary>
          <div className="App">
            <LottieAnimation />
            <Toaster
              position="top-center"
              toastStyle={{ zIndex: 9999 }}
              reverseOrder={false}
              autoClose={3000}
              hideProgressBar={false}
              closeOnClick
              pauseOnHover
              draggable
              theme="colored"
            />
            <Router />
          </div>
        </ErrorBoundary>
      </PersistGate>
    </Provider>
  );
}

export default App;
